import Vue from 'vue'

const systems = {
  windows: {
    id: 'windows',
    paste: 'Ctrl+V'
  },
  macos: {
    id: 'macos',
    paste: 'CMD+V'
  }
}

const platform = () => { return window.navigator.platform }

const detectOS = () => {
  const plat = platform()
  let os = null
  if (plat.startsWith('Mac')) {
    os = systems.macos
  } else {
    // default - for now
    os = systems.windows
  }
  return os
}

export const pasteMessage = () => {
  const os = detectOS()
  return Vue.i18n.translate('paste dialog message', { 'shortcut': os.paste })
}

export default {
  pasteMessage
}
